import { Schema } from "effect";
import { ContainerAction } from "@workerstation/shared/resources/container";
import { ContainerTarget, type ContainerStatus } from "../../api/containers/model.ts";
import { CatalogSelection } from "../catalog/model.ts";

export const ContainerExplorerAction = Schema.Union([
  Schema.TaggedStruct("SelectWorkspace", CatalogSelection.fields),
  Schema.TaggedStruct("Refresh", {}),
  Schema.TaggedStruct("Control", { target: ContainerTarget, selectionEpoch: Schema.Number, action: ContainerAction })
]);
export type ContainerExplorerAction = typeof ContainerExplorerAction.Type;
export const ContainerSettlement = Schema.Struct({ target: ContainerTarget, action: ContainerAction, outcome: Schema.Literals(["success", "refused"]), progress: Schema.Literals(["complete", "uncertain"]), message: Schema.NullOr(Schema.String) });
export type ContainerSettlement = typeof ContainerSettlement.Type;
export interface ContainerPending { readonly target: ContainerTarget; readonly selectionEpoch: number; readonly action: ContainerSettlement["action"] }
export interface ContainerMutationSnapshot {
  readonly pending: readonly ContainerPending[];
  readonly confirming: boolean;
  readonly states: ReadonlyMap<string, { readonly selectionEpoch: number; readonly state: ContainerStatus }>;
  readonly error: { readonly target: ContainerTarget; readonly selectionEpoch: number; readonly message: string } | null;
}
export const emptyContainerMutation = (): ContainerMutationSnapshot => ({ pending: [], confirming: false, states: new Map(), error: null });
export const formatContainerBytes = (value: number): string => value < 1024 ? `${value} B` : `${(value / 1024).toFixed(value < 10240 ? 1 : 0)} KiB`;
